// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lPLS","largestCol":"styles_largestCol__3A_b1","smallestCol":"styles_smallestCol__3BwN-"};